import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {WebOnboardingService} from '../../_services/web-onboarding.service';

@Component({
  selector: 'app-references',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.css'],
})
export class ReferencesComponent implements OnDestroy {
  @Input() validationToken = '';
  @Input() isPasswordRequired = false;
  @Output() saved = new EventEmitter<any>();

  form = new FormGroup({
    ref1FullName: new FormControl('', [Validators.required]),
    ref1Relationship: new FormControl('', [Validators.required]),
    ref1MobilePhone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(\+?54)?(9)?[1-9]\d{9}$/),
    ]),
    ref2FullName: new FormControl('', [Validators.required]),
    ref2Relationship: new FormControl('', [Validators.required]),
    ref2MobilePhone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^(\+?54)?(9)?[1-9]\d{9}$/),
    ]),
  });

  loading = false;
  errorMessage = '';

  private destroy$ = new Subject<void>();

  constructor(private onboardingService: WebOnboardingService) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    const references = [
      {
        name: this.form.value.ref1FullName,
        relation: this.form.value.ref1Relationship,
        phone: this.form.value.ref1MobilePhone,
        phoneType: 'mobile phone',
      },
      {
        name: this.form.value.ref2FullName,
        relation: this.form.value.ref2Relationship,
        phone: this.form.value.ref2MobilePhone,
        phoneType: 'mobile phone',
      },
    ];

    // If password is required, don't submit references yet.
    // The Password step will submit both references + password in one call.
    if (this.isPasswordRequired) {
      this.loading = false;
      this.saved.emit({_references: references});
      return;
    }

    const data = {
      token: this.validationToken,
      references,
    };

    this.onboardingService
      .saveReferences(data)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.saved.emit({...response, _references: references});
        },
        error: (err) => {
          this.loading = false;
          const body = err.error;
          if (body?.errors?.length) {
            this.errorMessage = body.errors.map((e: any) => e.message).filter(Boolean).join('\n');
          } else if (body?.message) {
            this.errorMessage = body.message;
          } else {
            this.errorMessage = 'Error al guardar las referencias. Intentá nuevamente.';
          }
        },
      });
  }
}
